<template>
  <div v-if="catalog" class="Main-Content">
    <ImportModal
      :catalog-id="catalog.id"
      :visible="showModal"
      @close="showModal = false"
      @upload="onFinishUpload"
    />
    <Page
      :title="catalog.name"
      :breadcrumbs="[
        {
          label: $t('Recommendations.catalogs'),
          onAction: () => $router.push({name: 'AccountRecCatalogs'})
        }
      ]"
      :primary-action="{
        label: $t('Recommendations.importCatalog'),
        onAction: startImport
      }"
      :secondary-actions="[
        {
          label: $t('Refresh'),
          onAction: refreshList
        }
      ]"
      size="fullWidth"
    >
      <Card>
        <CardSection>
          <Stats>
            <Stat
              :label="$t('ID')"
              :value="catalog.id"
            />
            <Stat
              :label="$t('Domain')"
              :value="catalog.domain"
            />
            <Stat
              :label="$t('Currency')"
              :value="catalog.currencyCode"
            />
            <Stat
              :label="$t('Language')"
              :value="catalog.languageCode"
            />
            <Stat
              :label="$t('Recommendations.totalItems')"
              :value="catalog.uniqueItemsFp"
              type="integer"
            />
          </Stats>
        </CardSection>
      </Card>
      <Card
        :title="$t('Recommendations.imports')"
      >
        <DataTable
          :loading="isLoadingList"
          :columns="[
            {
              key: 'importId',
              label: $t('ID')
            },
            {
              key: 'createdOn',
              label: $t('Date'),
              format: 'dateTimeShort'
            },
            {
              key: 'state',
              label: $t('State')
            },
            {
              key: 'filename',
              label: $t('Recommendations.filename')
            },
            {
              key: 'source',
              label: $t('Source')
            },
            {
              key: 'totalCount',
              label: $t('Recommendations.itemCount'),
              format: 'integer'
            },
            {
              key: 'googleSuccessCount',
              label: $t('Recommendations.successCount'),
              format: 'integer'
            },
            {
              key: 'googleFailureCount',
              label: $t('Recommendations.failedCount'),
              format: 'integer'
            }
          ]"
          :rows="imports"
          :row-actions="rowActionFn"
          :pagination="{
            offset: offset,
            limit: limit,
            total: imports.length,
            updateOffset: val => offset = val,
            updateLimit: updateLimit
          }"
        >
          <template v-slot:col:importId="{value}">
            <abbr :title="value">{{value.split('-')[0]}}</abbr>
          </template>
          <template v-slot:col:state="{value}">
            <Badge v-if="value === 'failed'" status="warning">{{$t(`Recommendations.${value}`)}}</Badge>
            <Badge v-else-if="value === 'completed'" status="success">{{$t(`Recommendations.${value}`)}}</Badge>
            <Badge v-else status="info">{{$t(`Recommendations.${value}`)}}</Badge>
          </template>
          <template v-slot:col:source="{value}">
            {{$t(`Recommendations.${value}`)}}
          </template>
        </DataTable>
      </Card>
    </Page>
  </div>
</template>

<script>
import ImportModal from '../components/dialogue/ImportModal'

export default {
  components: {
    ImportModal
  },
  data() {
    return {
      catalog: null,
      imports: [],
      showModal: false,
      isLoadingList: false,
      offset: 0,
      limit: 10,
    }
  },
  created() {
    this.limit = this.getTableLimit('tableLimit') || 10
    this.loadCatalog()
  },
  computed: {
    rowActionFn() {
      return (row) => {
        if (row.s3LogPath) {
          return [
            {
              label: this.$t('Recommendations.downloadLogs'),
              onAction: () => this.downloadLogs(row.importId)
            }
          ]
        }
        return []
      }
    }
  },
  methods: {
    async loadCatalog() {
      this.catalog = await this.api.getCatalog(this.$route.params.catalogId)
        .catch(this.apiCatch)
      await this.refreshList()
    },
    refreshList() {
      this.isLoadingList = true
      this.api.getImports(this.catalog.id)
        .then((data) => {
          this.imports = data
        })
        .catch(this.apiCatch)
        .finally(() => {
          this.isLoadingList = false
        })
    },
    startImport() {
      this.showModal = true
    },
    updateLimit(limit) {
      this.setTableLimit('tableLimit', limit)
      this.limit = limit
      this.offset = 0
    },
    downloadLogs(importId) {
      const toast = this.$ui.toast({
        title: `${this.$t('Recommendations.downloadingLogs')}...`,
        loading: true
      })
      this.api.downloadCatalogLogs({
        catalogId: this.catalog.id,
        importId: importId
      })
        .then((url) => {
          window.open(url)
          toast.loading = false
          toast.title = `${this.$t('Recommendations.downloaded')}`
        })
        .catch(this.apiCatch)
        .finally(() => {
          setTimeout(() => toast.remove(), 2000)
        })
    },
    onFinishUpload() {
      // Wait a little before refreshing the list to give backend some time to
      // create the import entry.
      setTimeout(() => {
        this.showModal = false
        this.refreshList()
      }, 2000)
    }
  }
}
</script>
